(function () {
  'use strict';

  var drawer = document.querySelector('[data-cart-drawer]');
  var overlay = document.querySelector('[data-cart-overlay]');
  var toggleBtns = document.querySelectorAll('[data-cart-toggle]');
  var closeBtns = document.querySelectorAll('[data-cart-close]');

  function openCart() {
    if (drawer) drawer.classList.add('is-open');
    if (overlay) overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeCart() {
    if (drawer) drawer.classList.remove('is-open');
    if (overlay) overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  toggleBtns.forEach(function (b) { b.addEventListener('click', openCart); });
  closeBtns.forEach(function (b) { b.addEventListener('click', closeCart); });
  if (overlay) overlay.addEventListener('click', closeCart);

  // モバイルナビゲーションドロワー
  var mobileNavToggle = document.querySelector('[data-mobile-nav-toggle]');
  var mobileNavDrawer = document.querySelector('[data-mobile-nav-drawer]');
  var mobileNavOverlay = document.querySelector('[data-mobile-nav-overlay]');
  var mobileNavClose = document.querySelector('[data-mobile-nav-close]');

  function openMobileNav() {
    if (mobileNavDrawer) mobileNavDrawer.classList.add('is-open');
    if (mobileNavOverlay) mobileNavOverlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeMobileNav() {
    if (mobileNavDrawer) mobileNavDrawer.classList.remove('is-open');
    if (mobileNavOverlay) mobileNavOverlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  if (mobileNavToggle) mobileNavToggle.addEventListener('click', openMobileNav);
  if (mobileNavClose) mobileNavClose.addEventListener('click', closeMobileNav);
  if (mobileNavOverlay) mobileNavOverlay.addEventListener('click', closeMobileNav);

  // カート追加トースト通知
  var cartToastTimer = null;
  function ensureCartToast() {
    var toast = document.querySelector('[data-cart-toast]');
    if (toast) return toast;
    toast = document.createElement('div');
    toast.className = 'cart-toast';
    toast.setAttribute('data-cart-toast', '');
    toast.innerHTML =
      '<div class="cart-toast__body">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>' +
        '<span class="cart-toast__message">カートに追加しました</span>' +
      '</div>' +
      '<button type="button" class="cart-toast__action">カートを見る</button>';
    document.body.appendChild(toast);
    toast.querySelector('.cart-toast__action').addEventListener('click', function () {
      hideCartToast();
      openCart();
    });
    return toast;
  }
  function hideCartToast() {
    var toast = document.querySelector('[data-cart-toast]');
    if (toast) toast.classList.remove('is-visible');
  }
  function showCartToast(message) {
    var toast = ensureCartToast();
    toast.querySelector('.cart-toast__message').textContent = message || 'カートに追加しました';
    toast.classList.add('is-visible');
    if (cartToastTimer) clearTimeout(cartToastTimer);
    cartToastTimer = setTimeout(hideCartToast, 3200);
  }

  function refreshCartSection() {
    fetch('/?section_id=cart-drawer')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var newItems = doc.querySelector('[data-cart-items]');
        var newSubtotal = doc.querySelector('[data-cart-subtotal]');
        var currentItems = document.querySelector('[data-cart-items]');
        var currentSubtotal = document.querySelector('[data-cart-subtotal]');
        if (newItems && currentItems) currentItems.innerHTML = newItems.innerHTML;
        if (newSubtotal && currentSubtotal) currentSubtotal.textContent = newSubtotal.textContent;
      });

    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var countEls = document.querySelectorAll('[data-cart-count]');
        countEls.forEach(function (el) { el.textContent = cart.item_count; });
        if (cart.item_count === 0) {
          countEls.forEach(function (el) { el.style.display = 'none'; });
        } else {
          countEls.forEach(function (el) { el.style.display = 'flex'; });
        }
      });
  }

  var EntowaCart = {
    addItem: function (variantId, quantity, properties) {
      var payload = { id: variantId, quantity: parseInt(quantity, 10) || 1 };
      if (properties && Object.keys(properties).length > 0) payload.properties = properties;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(function (r) {
          if (!r.ok) return r.json().then(function (e) { throw e; });
          return r.json();
        })
        .then(function () {
          refreshCartSection();
          openCart();
        })
        .catch(function (err) {
          alert((err && err.description) || 'カートへの追加に失敗しました。在庫をご確認ください。');
        });
    },
    changeItem: function (key, quantity) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: parseInt(quantity, 10) || 0 })
      }).then(refreshCartSection);
    }
  };
  window.EntowaCart = EntowaCart;

  document.addEventListener('click', function (e) {
    var removeBtn = e.target.closest('[data-cart-remove]');
    if (removeBtn) {
      EntowaCart.changeItem(removeBtn.getAttribute('data-cart-remove'), 0);
    }
    // えらべる詰め合わせBOX: 同じ箱の行をまとめて削除
    var removeBundleBtn = e.target.closest('[data-cart-remove-bundle]');
    if (removeBundleBtn) {
      var updates = {};
      removeBundleBtn.getAttribute('data-cart-remove-bundle').split(',').forEach(function (key) {
        if (key) updates[key] = 0;
      });
      removeBundleBtn.disabled = true;
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ updates: updates })
      }).then(function () {
        // カートページではページを再読み込みして小計等を更新、ドロワーでは部分更新
        if (removeBundleBtn.closest('.cart-bundle--page')) window.location.reload();
        else refreshCartSection();
      });
    }
  });

  // カートページ（main-cart.liquid）の数量ステッパー
  document.addEventListener('click', function (e) {
    var minus = e.target.closest('[data-line-minus]');
    var plus = e.target.closest('[data-line-plus]');
    if (minus || plus) {
      var idx = (minus || plus).getAttribute(minus ? 'data-line-minus' : 'data-line-plus');
      var input = document.querySelector('[data-line-qty="' + idx + '"]');
      if (input) {
        var v = parseInt(input.value || '0', 10);
        input.value = minus ? Math.max(0, v - 1) : v + 1;
      }
    }
  });

  // 商品カードからのクイック追加
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-quick-add]');
    if (!btn) return;
    e.preventDefault();

    if (btn.getAttribute('data-needs-options') === 'true') {
      // オプション（サイズ・種類）がある商品は商品ページへ誘導
      var url = btn.getAttribute('data-product-url');
      if (url) window.location.href = url;
      return;
    }

    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId || btn.classList.contains('is-loading')) return;

    btn.classList.add('is-loading');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (e) { throw e; });
        return r.json();
      })
      .then(function () {
        btn.classList.remove('is-loading');
        btn.classList.add('is-added');
        var label = btn.querySelector('[data-add-to-cart-label]');
        var originalLabel = label ? label.textContent : null;
        if (label) label.textContent = 'カートに追加しました';
        refreshCartSection();
        openCart();
        setTimeout(function () {
          btn.classList.remove('is-added');
          if (label && originalLabel) label.textContent = originalLabel;
        }, 1600);
      })
      .catch(function (err) {
        btn.classList.remove('is-loading');
        alert((err && err.description) || 'カートへの追加に失敗しました。在庫をご確認ください。');
      });
  });

  // 共有ボタン: URLコピー
  document.addEventListener('click', function (e) {
    var copyBtn = e.target.closest('[data-copy-url]');
    if (!copyBtn) return;
    var url = copyBtn.getAttribute('data-copy-url');

    function showCopied() {
      copyBtn.classList.add('is-copied');
      setTimeout(function () { copyBtn.classList.remove('is-copied'); }, 1800);
    }

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).then(showCopied);
    } else {
      var temp = document.createElement('textarea');
      temp.value = url;
      temp.style.position = 'fixed';
      temp.style.opacity = '0';
      document.body.appendChild(temp);
      temp.select();
      document.execCommand('copy');
      document.body.removeChild(temp);
      showCopied();
    }
  });

  // 共有ボタン: Instagram
  // InstagramにはURLを渡して投稿画面を開く公式の仕組みがないため、
  // スマホ（タッチ端末）は端末の共有メニューを開いてInstagramを選んでもらい、
  // PC等はURLをコピーしてInstagramのDM画面を開く
  document.addEventListener('click', function (e) {
    var igBtn = e.target.closest('[data-share-instagram]');
    if (!igBtn) return;
    var url = igBtn.getAttribute('data-share-url');
    var title = igBtn.getAttribute('data-share-title') || document.title;
    var isTouch = window.matchMedia && window.matchMedia('(pointer: coarse)').matches;

    if (isTouch && navigator.share) {
      navigator.share({ title: title, text: title, url: url }).catch(function () { /* キャンセル時は何もしない */ });
      return;
    }

    function showCopied() {
      igBtn.classList.add('is-copied');
      setTimeout(function () { igBtn.classList.remove('is-copied'); }, 2200);
    }
    function copyWithTextarea() {
      var temp = document.createElement('textarea');
      temp.value = url;
      temp.style.position = 'fixed';
      temp.style.opacity = '0';
      document.body.appendChild(temp);
      temp.select();
      var ok = false;
      try { ok = document.execCommand('copy'); } catch (err) { ok = false; }
      document.body.removeChild(temp);
      return ok;
    }

    // 新しいタブを開くとこのページのフォーカスが外れてコピーできなくなるため、先にコピーする
    if (copyWithTextarea()) {
      showCopied();
    } else if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).then(showCopied, function () { /* コピー不可の環境 */ });
    }

    window.open(isTouch ? 'https://www.instagram.com/' : 'https://www.instagram.com/direct/inbox/', '_blank', 'noopener');
  });

  // 商品横スクロール列の矢印ボタン
  document.querySelectorAll('[data-product-row]').forEach(function (row) {
    var track = row.querySelector('[data-row-track]');
    var prev = row.querySelector('[data-row-prev]');
    var next = row.querySelector('[data-row-next]');
    if (!track) return;
    function scrollAmount() {
      var item = track.querySelector('.product-row__item');
      return item ? item.offsetWidth + 20 : 280;
    }
    if (prev) prev.addEventListener('click', function () {
      track.scrollBy({ left: -scrollAmount() * 2, behavior: 'smooth' });
    });
    if (next) next.addEventListener('click', function () {
      track.scrollBy({ left: scrollAmount() * 2, behavior: 'smooth' });
    });
  });

  // ヘッダー: スクロールで少し縮める
  var siteHeader = document.querySelector('.site-header');
  if (siteHeader) {
    var headerTicking = false;
    function onHeaderScroll() {
      if (headerTicking) return;
      headerTicking = true;
      window.requestAnimationFrame(function () {
        var searchFocused = document.activeElement && document.activeElement.closest && document.activeElement.closest('.site-header__search-bar');
        // 縮む位置と戻る位置に幅を持たせ、境目でヘッダーが縮む/戻るを繰り返してカクつくのを防ぐ
        var y = window.scrollY;
        var scrolled = siteHeader.classList.contains('is-scrolled') ? y > 10 : y > 120;
        siteHeader.classList.toggle('is-scrolled', scrolled && !searchFocused);
        headerTicking = false;
      });
    }
    window.addEventListener('scroll', onHeaderScroll, { passive: true });
    onHeaderScroll();
  }

  // スクロールで要素をふわっと出現させる
  var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!prefersReducedMotion && 'IntersectionObserver' in window) {
    var revealObserver = new IntersectionObserver(function (entries, observer) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0, rootMargin: '0px 0px -60px 0px' });

    document.querySelectorAll('.section-padding').forEach(function (el) {
      el.classList.add('reveal');
      revealObserver.observe(el);
    });

    document.querySelectorAll('.product-grid, .news-grid, .farm-story__points, .category-grid, .profile-section__people').forEach(function (group) {
      Array.prototype.forEach.call(group.children, function (child, i) {
        child.classList.add('reveal');
        child.style.transitionDelay = (Math.min(i, 5) * 0.08) + 's';
        revealObserver.observe(child);
      });
    });
  }

  // ヒーロー右側: 写真スライドショー
  var heroGallery = document.querySelector('[data-hero-gallery]');
  if (heroGallery) {
    var heroSlides = heroGallery.querySelectorAll('.hero__slide');
    var heroDots = heroGallery.querySelectorAll('[data-hero-dot]');

    var heroIsMobile = window.matchMedia('(max-width: 900px)').matches;

    if (heroSlides.length > 1 && !heroIsMobile) {
      var heroIndex = 0;
      var heroTimer = null;

      var showHeroSlide = function (i) {
        heroIndex = (i + heroSlides.length) % heroSlides.length;
        heroSlides.forEach(function (s, idx) { s.classList.toggle('is-active', idx === heroIndex); });
        heroDots.forEach(function (d, idx) { d.classList.toggle('is-active', idx === heroIndex); });
      };

      var stopHeroAuto = function () {
        if (heroTimer) clearInterval(heroTimer);
      };
      var startHeroAuto = function () {
        if (prefersReducedMotion) return;
        stopHeroAuto();
        heroTimer = setInterval(function () { showHeroSlide(heroIndex + 1); }, 5000);
      };

      heroDots.forEach(function (dot, i) {
        dot.addEventListener('click', function () {
          showHeroSlide(i);
          startHeroAuto();
        });
      });

      heroGallery.addEventListener('mouseenter', stopHeroAuto);
      heroGallery.addEventListener('mouseleave', startHeroAuto);

      startHeroAuto();
    }
  }

  // ============================================
  // お気に入り（ゲストでも使える保存機能。localStorageに商品handleを保存）
  // ============================================
  var FAVORITES_KEY = 'entowa_favorites';

  function getFavorites() {
    try {
      var raw = localStorage.getItem(FAVORITES_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (e) {
      return [];
    }
  }

  function setFavorites(list) {
    try { localStorage.setItem(FAVORITES_KEY, JSON.stringify(list)); } catch (e) { /* ストレージ利用不可時は無視 */ }
    updateFavoriteCount();
  }

  function toggleFavorite(handle) {
    var list = getFavorites();
    var idx = list.indexOf(handle);
    if (idx === -1) {
      list.push(handle);
    } else {
      list.splice(idx, 1);
    }
    setFavorites(list);
    return list.indexOf(handle) !== -1;
  }

  function updateFavoriteCount() {
    var count = getFavorites().length;
    document.querySelectorAll('[data-favorite-count]').forEach(function (el) {
      el.textContent = count;
      el.style.display = count > 0 ? 'flex' : 'none';
    });
  }

  function syncFavoriteButtons() {
    var favs = getFavorites();
    document.querySelectorAll('[data-favorite-toggle]').forEach(function (btn) {
      var handle = btn.getAttribute('data-favorite-toggle');
      var active = favs.indexOf(handle) !== -1;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      btn.setAttribute('aria-label', active ? 'お気に入りから削除' : 'お気に入りに追加');
      var label = btn.querySelector('[data-favorite-label]');
      if (label) label.textContent = active ? 'お気に入り済み' : 'お気に入りに追加';
    });
  }

  // お気に入り追加/削除トースト（画面右上、ヘッダー直下に表示）
  var favoriteToastTimer = null;
  function ensureFavoriteToast() {
    var toast = document.querySelector('[data-favorite-toast]');
    if (toast) return toast;
    var favLink = document.querySelector('.header-icon-btn--favorites');
    var favUrl = favLink ? favLink.getAttribute('href') : '/pages/favorites';
    toast = document.createElement('div');
    toast.className = 'favorite-toast';
    toast.setAttribute('data-favorite-toast', '');
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');
    toast.innerHTML =
      '<span class="favorite-toast__icon">' +
        '<svg viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>' +
      '</span>' +
      '<span class="favorite-toast__message"></span>' +
      '<a class="favorite-toast__link" href="' + favUrl + '">一覧を見る</a>';
    document.body.appendChild(toast);
    toast.addEventListener('mouseenter', function () { if (favoriteToastTimer) clearTimeout(favoriteToastTimer); });
    toast.addEventListener('mouseleave', function () { favoriteToastTimer = setTimeout(hideFavoriteToast, 1500); });
    return toast;
  }
  function hideFavoriteToast() {
    var toast = document.querySelector('[data-favorite-toast]');
    if (toast) toast.classList.remove('is-visible');
  }
  function showFavoriteToast(added) {
    var toast = ensureFavoriteToast();
    // ヘッダーの高さはスクロールで変わるため、表示のたびにヘッダー下端を測って位置を決める
    var header = document.querySelector('.site-header');
    var top = header ? Math.max(header.getBoundingClientRect().bottom, 0) : 0;
    toast.style.top = (top + 12) + 'px';
    toast.classList.toggle('is-removed', !added);
    toast.querySelector('.favorite-toast__message').textContent =
      added ? 'お気に入りに追加しました' : 'お気に入りから削除しました';
    // 連続クリック時もアニメーションをやり直す
    toast.classList.remove('is-visible');
    void toast.offsetWidth;
    toast.classList.add('is-visible');
    if (favoriteToastTimer) clearTimeout(favoriteToastTimer);
    favoriteToastTimer = setTimeout(hideFavoriteToast, 3000);
  }

  function bumpFavoriteBadge() {
    document.querySelectorAll('.header-icon-btn--favorites').forEach(function (el) {
      el.classList.remove('is-bump');
      void el.offsetWidth;
      el.classList.add('is-bump');
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-favorite-toggle]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var added = toggleFavorite(btn.getAttribute('data-favorite-toggle'));
    syncFavoriteButtons();
    if (added) {
      btn.classList.remove('is-pop');
      void btn.offsetWidth;
      btn.classList.add('is-pop');
      bumpFavoriteBadge();
    }
    showFavoriteToast(added);
  });

  updateFavoriteCount();
  syncFavoriteButtons();

  // お気に入り一覧ページ: 保存されたhandleから商品情報を取得して描画
  var favoritesGrid = document.querySelector('[data-favorites-grid]');
  if (favoritesGrid) {
    var favoritesEmpty = document.querySelector('[data-favorites-empty]');
    var handles = getFavorites();

    function escapeHtml(str) {
      var div = document.createElement('div');
      div.textContent = str || '';
      return div.innerHTML;
    }

    var HEART_ICONS =
      '<svg class="icon-heart-outline" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>' +
      '<svg class="icon-heart-filled" viewBox="0 0 24 24" fill="currentColor"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>';

    function renderFavoriteCard(p) {
      var img = p.featured_image || (p.images && p.images[0]) || '';
      var imgUrl = img ? (img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=600') : '';
      var price = Math.floor(p.price / 100).toLocaleString('ja-JP');
      var compareAt = (p.compare_at_price && p.compare_at_price > p.price) ? Math.floor(p.compare_at_price / 100).toLocaleString('ja-JP') : null;
      var soldOut = !p.available;
      var needsOptions = p.variants && p.variants.length > 1;
      var firstVariantId = p.variants && p.variants[0] ? p.variants[0].id : '';
      // 「まとめてカートに入れる」の対象: 在庫あり・選択肢なし（カードの「カートに入れる」と同じ条件）
      var bulkEligible = !soldOut && !needsOptions && firstVariantId && p.variants[0].available !== false;

      return (
        '<div class="product-card" data-product-card' + (bulkEligible ? ' data-bulk-variant-id="' + firstVariantId + '"' : '') + '>' +
          '<div class="product-card__media">' +
            '<a href="' + p.url + '" class="product-card__image-wrap">' +
              (imgUrl ? '<img class="product-card__image" src="' + imgUrl + '" alt="' + escapeHtml(p.title) + '" loading="lazy" width="600" height="480">' : '') +
              (soldOut ? '<span class="product-card__badge product-card__badge--soldout">売り切れ</span>' : '') +
            '</a>' +
            '<button type="button" class="product-card__favorite is-active" data-favorite-toggle="' + p.handle + '" aria-label="お気に入りから削除" aria-pressed="true">' + HEART_ICONS + '</button>' +
          '</div>' +
          '<div class="product-card__body">' +
            (p.type ? '<div class="product-card__category">' + escapeHtml(p.type) + '</div>' : '') +
            '<a href="' + p.url + '" class="product-card__title-link"><h3 class="product-card__title">' + escapeHtml(p.title) + '</h3></a>' +
            '<div class="product-card__price price">' +
              (compareAt ? '<span class="price--compare"><span class="price-symbol">&yen;</span>' + compareAt + '</span>' : '') +
              '<span class="price-symbol">&yen;</span>' + price + '<span class="price__tax-note">（税込）</span>' +
            '</div>' +
            '<a href="' + p.url + '" class="product-card__view-more">商品の詳細を見る<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg></a>' +
            (!soldOut ?
              '<button type="button" class="product-card__add-to-cart" aria-label="' + (needsOptions ? '商品を選ぶ' : 'カートに入れる') + '" data-quick-add data-variant-id="' + firstVariantId + '"' + (needsOptions ? ' data-needs-options="true" data-product-url="' + p.url + '"' : '') + '>' +
                '<span class="product-card__add-to-cart-icon">' +
                  '<svg class="icon-cart" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M6 6h15l-1.5 9h-12z"/><circle cx="9" cy="20" r="1"/><circle cx="18" cy="20" r="1"/><path d="M6 6L4 2H2"/></svg>' +
                  '<svg class="icon-check" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>' +
                '</span>' +
                '<span class="product-card__add-to-cart-label" data-add-to-cart-label>' + (needsOptions ? '商品を選ぶ' : 'カートに入れる') + '</span>' +
              '</button>'
            :
              '<div class="product-card__add-to-cart is-soldout" aria-disabled="true">' +
                '<span class="product-card__add-to-cart-label">売り切れ</span>' +
              '</div>'
            ) +
          '</div>' +
        '</div>'
      );
    }

    if (handles.length === 0) {
      if (favoritesEmpty) favoritesEmpty.style.display = '';
    } else {
      Promise.all(handles.map(function (handle) {
        return fetch('/products/' + handle + '.js').then(function (r) {
          return r.ok ? r.json() : null;
        }).catch(function () { return null; });
      })).then(function (products) {
        var html = '';
        products.forEach(function (p) { if (p) html += renderFavoriteCard(p); });
        favoritesGrid.innerHTML = html;
        if (!html && favoritesEmpty) favoritesEmpty.style.display = '';
        syncFavoriteButtons();
        updateFavoritesBulk();
      });
    }

    // まとめてカートに入れる
    var bulkWrap = document.querySelector('[data-favorites-bulk]');
    var bulkBtn = document.querySelector('[data-favorites-bulk-add]');
    var bulkLabel = document.querySelector('[data-favorites-bulk-label]');
    var bulkNote = document.querySelector('[data-favorites-bulk-note]');

    function getBulkVariantIds() {
      return Array.prototype.map.call(
        favoritesGrid.querySelectorAll('[data-product-card][data-bulk-variant-id]'),
        function (card) { return card.getAttribute('data-bulk-variant-id'); }
      );
    }

    function updateFavoritesBulk() {
      if (!bulkWrap) return;
      var total = favoritesGrid.querySelectorAll('[data-product-card]').length;
      var count = getBulkVariantIds().length;
      bulkWrap.hidden = count === 0;
      if (count === 0) return;
      if (bulkLabel && !bulkBtn.classList.contains('is-loading')) bulkLabel.textContent = 'まとめてカートに入れる（' + count + '点）';
      var skipped = total - count;
      if (bulkNote) {
        bulkNote.hidden = skipped === 0;
        bulkNote.textContent = '※ 種類・容量を選ぶ商品、売り切れの商品（' + skipped + '点）は含まれません。各商品ページからお選びください。';
      }
    }

    function addFavoritesOneByOne(ids) {
      var added = 0;
      return ids.reduce(function (chain, id) {
        return chain.then(function () {
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ id: id, quantity: 1 })
          }).then(function (r) { if (r.ok) added++; }).catch(function () {});
        });
      }, Promise.resolve()).then(function () { return added; });
    }

    if (bulkBtn) {
      bulkBtn.addEventListener('click', function () {
        var ids = getBulkVariantIds();
        if (ids.length === 0 || bulkBtn.classList.contains('is-loading')) return;
        bulkBtn.classList.add('is-loading');
        bulkBtn.disabled = true;
        if (bulkLabel) bulkLabel.textContent = 'カートに追加しています…';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: ids.map(function (id) { return { id: id, quantity: 1 }; }) })
        })
          .then(function (r) {
            if (r.ok) return ids.length;
            // 1点でも在庫切れ等があると一括追加は全体が失敗するため、1点ずつ追加し直す
            return addFavoritesOneByOne(ids);
          })
          .then(function (added) {
            bulkBtn.classList.remove('is-loading');
            bulkBtn.disabled = false;
            if (added === 0) {
              updateFavoritesBulk();
              alert('カートへの追加に失敗しました。在庫をご確認ください。');
              return;
            }
            refreshCartSection();
            openCart();
            if (bulkLabel) bulkLabel.textContent = added + '点をカートに追加しました';
            setTimeout(updateFavoritesBulk, 2000);
          })
          .catch(function () {
            bulkBtn.classList.remove('is-loading');
            bulkBtn.disabled = false;
            updateFavoritesBulk();
            alert('カートへの追加に失敗しました。時間をおいて再度お試しください。');
          });
      });
    }

    document.addEventListener('click', function (e) {
      var removeBtn = e.target.closest('[data-favorite-toggle]');
      if (!removeBtn || !favoritesGrid.contains(removeBtn)) return;
      var card = removeBtn.closest('[data-product-card]');
      if (card) card.remove();
      if (favoritesGrid.children.length === 0 && favoritesEmpty) favoritesEmpty.style.display = '';
      updateFavoritesBulk();
    });
  }

  // ベリー診断の結果から商品ページへ来た場合、カート属性に「診断経由」を記録する（注文の追加情報に残る）
  (function () {
    var match = window.location.pathname.match(/\/products\/([^\/?#]+)/);
    if (!match) return;
    var info = null;
    try { info = JSON.parse(sessionStorage.getItem('entowa_diagnosis_click') || 'null'); } catch (e) { info = null; }
    if (!info || info.handle !== decodeURIComponent(match[1])) return;
    if (Date.now() - (info.at || 0) > 24 * 60 * 60 * 1000) return;
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ attributes: { '診断経由': 'No.' + info.rank + '（' + info.handle + '・タイプ' + String(info.type || '').toUpperCase() + '）' } })
    }).catch(function () {});
  })();

  // 他のセクション（詰め合わせビルダー等）からカートの再描画・表示を呼べるようにする
  window.entowaCart = { refresh: refreshCartSection, open: openCart };
})();
